"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _verticalButton = require("./verticalButton.proptypes");

var _constant = require("./constant");

var _constant2 = require("../JourneyPriceCTA/constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // eslint-disable-next-line import/no-extraneous-dependencies


var Showbutton = _styledComponents.default.div.withConfig({
  displayName: "VerticalButton__Showbutton",
  componentId: "sc-1encc26-0"
})(["height:auto;word-wrap:break-word;position:fixed;right:0;writing-mode:vertical-rl;", ";", ";", " ", ";z-index:5;text-align:center;cursor:pointer;"], function (_ref) {
  var verticalPosition = _ref.verticalPosition,
      verticalButtonCustomProperties = _ref.verticalButtonCustomProperties;
  return verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.bottomPosition ? "" : "top: ".concat(verticalPosition || '70%');
}, function (_ref2) {
  var theme = _ref2.theme,
      invert = _ref2.invert,
      border = _ref2.border;
  return (0, _styledComponents.css)(["transform:", ";border-radius:", ";"], function () {
    return invert ? 'rotate(-360deg)' : 'rotate(-180deg)';
  }, function () {
    return invert ? "".concat(theme.borderRadius.border, " 0px 0px ").concat(theme.borderRadius.border) : "0px ".concat(theme.borderRadius[border], " ").concat(theme.borderRadius[border], " 0px");
  });
}, function (props) {
  return (0, _styledComponents.css)(["background-color:", ";color:", ";font-family:", ";line-height:", ";padding:", " ", ";font-size:", ";"], props.theme.colors.neutral, props.theme.colors.default, props.theme.fontFamily.default, props.theme.lineHeight.small, props.theme.space.tiny, props.theme.space.micro, props.theme.fontSize.medium);
}, function (_ref3) {
  var isMobile = _ref3.isMobile,
      theme = _ref3.theme,
      verticalButtonCustomProperties = _ref3.verticalButtonCustomProperties;
  return isMobile && (0, _styledComponents.css)(["font-size:", ";padding:", ";border-radius:", ";font-style:", ";font-weight:", ";line-height:", ";bottom:", ";height:", ";"], verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.fontSize ? verticalButtonCustomProperties.fontSize : theme.fontSize.XSmall, verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.padding ? verticalButtonCustomProperties.padding : 'theme.space.tiny 2px', verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.borderRadius ? verticalButtonCustomProperties.borderRadius : '0px', verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.fontStyle ? 'normal' : '', verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.weight ? verticalButtonCustomProperties.weight : '', verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.lineHeight ? verticalButtonCustomProperties.lineHeight : '', verticalButtonCustomProperties !== null && verticalButtonCustomProperties !== void 0 && verticalButtonCustomProperties.bottomPosition ? verticalButtonCustomProperties.bottomPosition : '', (verticalButtonCustomProperties === null || verticalButtonCustomProperties === void 0 ? void 0 : verticalButtonCustomProperties.height) || 'auto');
});

var VerticalButton = function VerticalButton(props) {
  var isMobile = props.isMobile,
      verticalPosition = props.verticalPosition,
      verticalButtonTitle = props.verticalButtonTitle,
      accessible = props.accessible,
      theme = props.theme,
      id = props.id,
      onClickHandle = props.onClickHandle,
      cultureCode = props.cultureCode,
      fireGtm = props.fireGtm,
      gtmEventData = props.gtmEventData,
      verticalButtonCustomProperties = props.verticalButtonCustomProperties;
  var tabIndex = !accessible ? '-1' : '0';

  function fireGtmHandler() {
    var gtmEvent = gtmEventData ? gtmEventData.replace('{{action}}', 'expand' || null) : null; // eslint-disable-next-line no-unused-expressions

    fireGtm ? fireGtm(gtmEvent, true) : null;
  }

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var handleClick = function handleClick() {
    onClickHandle();

    if (fireGtm) {
      fireGtmHandler();
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof document !== 'undefined') {
      var bodyElement = document.getElementsByTagName('body');

      if (bodyElement) {
        bodyElement[0].style.removeProperty('overflow');
      }
    }
  }, []);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Showbutton, {
      id: id,
      verticalPosition: verticalPosition,
      isMobile: isMobile,
      accessible: accessible,
      onClick: handleClick,
      tabIndex: tabIndex,
      invert: _constant.INVERTED.includes(cultureCode),
      verticalButtonCustomProperties: verticalButtonCustomProperties,
      border: theme === _constant2.THEMES.MOVE ? 'XXnormal' : 'normal'
    }, verticalButtonTitle);
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

VerticalButton.propTypes = _verticalButton.VerticalButtonProps.PropTypes;
VerticalButton.defaultProps = _verticalButton.VerticalButtonProps.DefaultProps;
var _default = VerticalButton;
exports.default = _default;